import { localizedRouteGroup } from 'routing/routes';

import { ORG_TYPE_URL_SEGMENTS } from './org.route-segments';

export const orgSegmentedRoutes = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeUrlSegment) =>
    localizedRouteGroup.route(`${orgTypeUrlSegment}/:orgIdDashSlug`),
);
